<nz-spin [nzSpinning]="processingOCR" nzTip="Processing OCR..."> 
  <div class="flexie-auto-grid p-b-20">
    <div>
      <h3 class="heading">File Upload</h3>
    </div>
    <div class="text-a-right">
      <button nz-button [nzType]="'primary'" (click)="fetchFile(previewFileUrl,'download')">Download Template</button>
    </div>
  </div>
  <!-- Upload -->
  <nz-upload *ngIf="showUpload && source != 'transaction'" nzType="drag" [nzLimit]="1" [nzRemove]="fileRemove" 
  [nzBeforeUpload]="fileUploadBefore" (click)="uploadSource='excel'">
  
    <!-- nzType="drag"
  [nzMultiple]="true"
  [nzLimit]="2"
  nzAction="https://jsonplaceholder.typicode.com/posts/"
  (nzChange)="handleFileUpload($event)" -->
    <p class="ant-upload-drag-icon">
      <i nz-icon nzType="inbox" class="anticon anticon-inbox"></i>
    </p>
    <p class="ant-upload-text">Click or drag file to this area to upload</p>
    <p class="ant-upload-hint">
      Single file & bulk upload supported. Strictly prohibited from uploading internal company data or other confidential
      data
    </p>
  </nz-upload>
  <!-- <div *ngIf="fileList">
    <span nz-icon nzType="paper-clip" nzTheme="outline"></span> <a rel="noopener noreferrer" target="_blank" href=""
      title="fileList['name'] ? fileList['name'] : '-'">{{fileList['name'] ? fileList['name'] : '-'}}</a>
  </div> -->
  
  <div *ngIf="showWarningRibbon" class="m-t-20">
    <span>
      <nz-alert nzType="warning" nzCloseable
        nzMessage="Warning: After uploading the ZIP file, please click the submit button to ensure the file is successfully uploaded."
        nzShowIcon>
      </nz-alert>
    </span>
  </div>
  <!-- style="margin-top: 4.5em;" -->
  <div *ngIf="false" class="p-t-20">
    <h3 *ngIf="batchId" class="heading">Bulk Document Upload ( {{batchId}} )</h3>
    <h3 *ngIf="!batchId" class="heading">Bulk Document Upload</h3>
    <nz-upload nzType="upload" [nzLimit]="1" [nzRemove]="fileRemoveZIP" [nzBeforeUpload]="fileUploadBefore" (click)="uploadSource='zip'">
      <button nz-button class="m-t-10 d-i-b">
        <span><i nz-icon  class="anticon anticon-upload"></i> Upload </span>
      </button>
    </nz-upload>
  </div>
   <!-- [nzData]="bulkDocumentData" -->
  <nz-table *ngIf=" false && refreshComponentToggle" #fileUploadTable [nzData]="uploadedFileData" [nzShowPagination]="true" nzZIndex="100" style="margin-top: 0.5em;">
    <thead>
      <tr>
        <th translate>Sr. No</th>
        <th translate>File Name</th>
        <!-- <th translate>Action</th> -->
    </tr>
    </thead>
    <tbody> 
      <!-- -->
      <tr *ngFor="let data of fileUploadTable.data; let i = index">
        <td>{{i+1}}</td>
        <td>{{data.fileName}}</td>
        <!-- <td><span class="clickable hover-underline color-blue" (click)="deleteDocument(i)">Delete</span></td> -->
      </tr>
    </tbody>
  </nz-table>
  
  
  <!-- <h3 class="heading m-t-20">Records Uploaded ({{bulkMetaDataList?.length}})</h3>
  <nz-table #intimationMetaDataTable [nzData]="bulkMetaDataList" [nzShowPagination]="true" [nzScroll]="{ x: '3700px' }">
    <thead>
      <tr>
        <th nzLeft="0px" nzWidth="40px"> </th>
        <th class="col-min-width"> Group policy Holder name </th>
        <th class="col-min-width">Event Date</th>
        <th class="col-min-width">Event Time</th>
        <th class="col-min-width">Event Type</th>
        <th class="col-min-width">Policy Num</th>
        <th class="col-min-width">Insured Name</th>
        <th class="col-min-width">Employee Number</th>
        <th class="col-min-width">Loan Number</th>
        <th class="col-min-width">Member Number</th>
        <th class="col-min-width">Member Number flag</th>
        <th class="col-min-width">Cerficate Of issuance</th>
        <th class="col-min-width">Gender of Insured</th>
        <th class="col-min-width">Insured DOB</th>
        <th class="col-min-width">Nominee First Name</th>
        <th class="col-min-width">Nominee Gender</th>
        <th class="col-min-width">Nominee address</th>
        <th class="col-min-width">Nominee Contact Num</th>
        <th class="col-min-width">Relation With Insured</th>
        <th class="col-min-width">Member Addition Date</th>
        <th class="col-min-width">Cause of event</th>
        <th class="col-min-width">Sum insured</th>
        <th class="col-min-width">Loan Amount</th>
        <th class="col-min-width">Loan Recovered Amount</th>
        <th class="col-min-width">Outstanding loan amouny</th>
        <th class="col-min-width">Account Number</th>
        <th class="col-min-width">IFSC Code</th>
        <th class="col-min-width">IFSC Code</th>
        <th class="col-min-width">Bank Name</th>
        <th nzRight="0px" nzWidth="200px">Documents</th>
        
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of intimationMetaDataTable.data; let i=index;">
        <td nzLeft="0px" nzWidth="40px">
          <label nz-checkbox [(ngModel)]="data['selected']" nzValue="data.id"
            (ngModelChange)="emitSelectedIntimation($event,data.id)"></label>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.grpPolHolName" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <nz-date-picker [(ngModel)]="data.eventDt" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"
            [nzDisabled]="true">
          </nz-date-picker>
          <nz-date-picker [(ngModel)]="data.eventDt1" (ngModelChange)="checkAllErrors()"
            [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"
            (ngModelChange)="onChange($event,'RETYPE',data.eventDt)" [nzDisabled]="false">
          </nz-date-picker>
  
          <nz-form-explain *ngIf="datesAreEqual == false">
            <p style="color:red">
              Data not matched
            </p>
          </nz-form-explain>
  
        </td>
  
        <td>
  
          <nz-time-picker id="eventTime" [(ngModel)]="data.eventTm" style="width:100%" [nzFormat]="'HH:mm'"
            [nzDisabled]="true">
          </nz-time-picker> <br>
  
          <nz-time-picker id="eventTime" [(ngModel)]="data.eventTm1" (ngModelChange)="checkAllErrors()" style="width:100%"
            [nzFormat]="'HH:mm'" [nzDisabled]="false">
          </nz-time-picker><br>
  
          <nz-form-explain *ngIf="data.eventTm != data.eventTm">
            <p style="color:red">
              Data not matched
            </p>
          </nz-form-explain>
  
        </td>
  
        <td>
          <input nz-input [(ngModel)]="data.eventTypeCd" disabled /><br>
          <input nz-input [(ngModel)]="data.eventTypeCd1" (ngModelChange)="checkAllErrors()" />
  
          <nz-form-explain *ngIf="data.eventTypeCd != data.eventTypeCd1">
            <p style="color:red">
              Data not matched
            </p>
          </nz-form-explain>
        </td>
  
        <td>
          <input nz-input [(ngModel)]="data.policyNum" disabled /><br>
          <input nz-input [(ngModel)]="data.policyNum1" (ngModelChange)="checkAllErrors()" />
  
          <nz-form-explain *ngIf="data.policyNum != data.policyNum1">
            <p style="color:red">
              Data not matched
            </p>
          </nz-form-explain>
        </td>
  
  
        <td>
          <input nz-input [(ngModel)]="data.insFirstName" disabled /><br>
          <input nz-input [(ngModel)]="data.insFirstName1" (ngModelChange)="checkAllErrors()" />
          <nz-form-explain *ngIf="data.insFirstName != data.insFirstName1">
            <p style="color:red">
              Data not matched
            </p>
          </nz-form-explain>
        </td>
        
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.clientNum" disabled /><br>
        </td>
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.loanNum" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.memberNum" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.memberFL" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.coiNum" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.insGender" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.insDateOfBirth" disabled /><br>
        </td>
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.nomFirstName" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.nomGender" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.nomAddressLine1" disabled /><br>
        </td>
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.nomContactNum" disabled /><br>
        </td>
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.relatedToInsuredCd" disabled /><br>
        </td>
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.memberAdditionDt" disabled /><br>
        </td>
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.causeOfDeathCd" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.sumInsured" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.loanAmt" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.totValueAmt" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.cashValueAmt" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.accountHolderName" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.accountNumber" disabled /><br>
        </td>
  
        <td class="col-min-width">
          <input nz-input [(ngModel)]="data.branchIdNum1" disabled /><br>
        </td>
  
        <td>
          <input nz-input [(ngModel)]="data.branchName" disabled /><br>
        </td>
        <td nzRight="0px" nzWidth="200px">
          <a href="javascript:void(0)" (click)="openDocumentModel(data?.guid)">
            Document
          </a>
        </td>
  
      </tr>
    </tbody>
  </nz-table> -->
  
  
  <!-- Footer -->
  <div class="card-summary-data-footer _data-footer-primary" *ngIf="source != 'transaction'">
    <div>
  
    </div>
    <div>
      <button nz-button class="m-r-10" [nzType]="'primary'" (click)="uploadExcel()" [nzLoading]="_transactionInProgress"
        [disabled]="HasError">Submit</button>
    </div>
  </div>
  </nz-spin>